module.exports = __webpack_public_path__ + "img/logo12com_mobile.18c76fb0.png";